// The site's gold, for the places the site's stylesheet never reaches: emails,
// the printed calculator report, chart libraries that want a colour value, the
// stand-alone action pages and an agency's default accent. Everywhere else the
// same colours are the theme tokens in app/styles/site.css (bg-gold,
// text-champagne, ...), and a test keeps the two in step.
//
// Two golds and no more (owner, 2026-09-24: "the number of colours cut to the
// necessary minimum"): GOLD for fills and accents, CHAMPAGNE, the light one,
// for text and bright fills on black. GOLD_ON_LIGHT is the gold that stays
// legible on white (4.5:1), used only where the background is white.

export const GOLD = '#c5a880';
export const CHAMPAGNE = '#e5d3b3';
export const GOLD_ON_LIGHT = '#8c6b3e';

// The status colours, the same as --color-danger/-success/-warning.
export const DANGER = '#cf7a5f';
export const SUCCESS = '#a9b46e';
export const WARNING = '#ddb75a';
export const INFO = '#8ea3b0';

// Neutral greys for chart series with no colour of their own (paused,
// archived, unknown): Tailwind's neutral-500, -700 and -400.
export const GREY = '#737373';
export const GREY_DARK = '#404040';
export const GREY_LIGHT = '#a3a3a3';
